<template>
  <div class="choice-practice-base-page" v-loading="loading">
    <div class="choice-shell">
      <div class="choice-module">
        <div class="choice-title">选择实习单位</div>

        <div class="choice-card">
          <el-checkbox-group
            v-model="selectedTrainList"
            class="choice-group"
            @change="handleSelectionChange"
          >
            <div v-for="item in trainList" :key="item.tbId" class="choice-item">
              <el-checkbox
                :label="item.tbId"
                :disabled="isCheckboxDisabled(item.tbId)"
              >
                <span
                  class="choice-name"
                  :class="{ 'is-selected': isSelected(item.tbId) }"
                >
                  {{ item.name }}
                </span>
              </el-checkbox>
              <span v-if="getWishLabel(item.tbId)" class="wish-label">
                {{ getWishLabel(item.tbId) }}
              </span>
            </div>
          </el-checkbox-group>

          <div class="choice-actions">
            <button type="button" class="confirm-btn" @click="handleConfirm">
              确认选择
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { httpRequest } from "@/axios/axios-api";

export default {
  name: "ChoicePracticeBase",
  data() {
    return {
      loading: false,
      arId: "",
      majorId: "",
      trainList: [],
      selectedTrainList: [],
      lastSelectedTrainList: [],
      isAdjustingSelection: false
    };
  },
  created() {
    this.initPage();
  },
  methods: {
    async initPage() {
      this.arId = this.$route.query.arId || "";
      this.majorId = this.$route.query.majorId || "";
      if (!this.arId || !this.majorId) {
        this.$message.error("实习单位信息异常");
        this.$router.push("/studyPage");
        return;
      }
      this.loading = true;
      try {
        await this.loadTrainList();
      } finally {
        this.loading = false;
      }
      this.showInstructionDialog();
    },
    async loadTrainList() {
      try {
        const res = await httpRequest("/app/train/base/bases-no-page", "get", {
          majorId: this.majorId
        });
        if (res && res.code === 200 && Array.isArray(res.data)) {
          this.trainList = res.data;
          return;
        }
      } catch (error) {
        void error;
      }
      this.trainList = [];
      this.$message.error("实习单位加载失败");
    },
    showInstructionDialog() {
      const html =
        "1、临床实践单位录取依据为个人意向及个人理论考试成绩。若某实习单位的填报人数超出限报人数，我会会结合学员的理论考试成绩进行调剂分配。<br>" +
        "2、学员可选择三个意向，优先录取第一意向，若第一意向不能录取时，按第二意向录取，若第二意向不能录取时，按第三意向录取。<br>" +
        "3、第一意向：可选择本专业所有临床实践教学单位；<br>" +
        "第二、三意向：可选择本专业除去山东省立医院、山东大学齐鲁医院之外的临床实践教学单位。<br>" +
        "三个意向不可重复选择。";
      this.$alert(html, "专科护士培训班临床实践单位意向填报说明", {
        confirmButtonText: "好的，我知道了",
        dangerouslyUseHTMLString: true,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        customClass: "practice-instruction-dialog"
      }).catch(() => {});
    },
    getRestrictedHospitalNames() {
      return ["山东省立医院", "山东大学齐鲁医院"];
    },
    getBaseById(tbId) {
      return this.trainList.find(item => item.tbId === tbId) || null;
    },
    normalizeName(name) {
      return typeof name === "string" ? name.trim() : "";
    },
    isRestrictedBase(tbId) {
      const base = this.getBaseById(tbId);
      if (!base) {
        return false;
      }
      const name = this.normalizeName(base.name);
      return this.getRestrictedHospitalNames().includes(name);
    },
    handleSelectionChange(nextSelectedList) {
      if (this.isAdjustingSelection) {
        this.lastSelectedTrainList = this.selectedTrainList.slice();
        return;
      }
      const nextList = Array.isArray(nextSelectedList)
        ? nextSelectedList.slice()
        : [];
      const addedId = nextList.find(
        tbId => !this.lastSelectedTrainList.includes(tbId)
      );

      if (addedId && nextList.length > 1 && this.isRestrictedBase(addedId)) {
        this.isAdjustingSelection = true;
        this.selectedTrainList = this.lastSelectedTrainList.slice();
        this.$nextTick(() => {
          this.isAdjustingSelection = false;
        });
        this.$message.warning(
          "第二、三志愿不可选择山东省立医院、山东大学齐鲁医院"
        );
        return;
      }

      this.lastSelectedTrainList = nextList;
    },
    isSelected(tbId) {
      return this.selectedTrainList.includes(tbId);
    },
    isCheckboxDisabled(tbId) {
      if (this.isSelected(tbId)) {
        return false;
      }
      if (this.selectedTrainList.length >= 1 && this.isRestrictedBase(tbId)) {
        return true;
      }
      return this.selectedTrainList.length >= 3;
    },
    getWishLabel(tbId) {
      const idx = this.selectedTrainList.indexOf(tbId);
      if (idx === 0) {
        return "第一志愿";
      }
      if (idx === 1) {
        return "第二志愿";
      }
      if (idx === 2) {
        return "第三志愿";
      }
      return "";
    },
    validateSelectedOrder(showMessage = false) {
      if (this.selectedTrainList.length !== 3) {
        if (showMessage) {
          this.$message.warning("请选择三个实习单位");
        }
        return false;
      }

      const uniqueSize = new Set(this.selectedTrainList).size;
      if (uniqueSize !== this.selectedTrainList.length) {
        if (showMessage) {
          this.$message.warning("三个志愿不可重复选择");
        }
        return false;
      }

      const secondId = this.selectedTrainList[1];
      const thirdId = this.selectedTrainList[2];
      if (this.isRestrictedBase(secondId) || this.isRestrictedBase(thirdId)) {
        if (showMessage) {
          this.$message.warning(
            "第二、三志愿不可选择山东省立医院、山东大学齐鲁医院"
          );
        }
        return false;
      }
      return true;
    },
    async handleConfirm() {
      if (!this.validateSelectedOrder(true)) {
        return;
      }
      try {
        await this.$confirm("确认要提交单位志愿吗？", "提示", {
          confirmButtonText: "确认提交",
          cancelButtonText: "取消",
          type: "warning"
        });
      } catch (error) {
        return;
      }
      this.loading = true;
      try {
        const res = await httpRequest(
          "/app/exam/apply/pre-choice-base",
          "put",
          {
            arId: String(this.arId),
            trainBasePreselect: this.selectedTrainList.join(",")
          }
        );
        if (res && res.code === 200) {
          this.$message.success("选择实习单位成功");
          this.goBack();
        }
      } catch (error) {
        void error;
      } finally {
        this.loading = false;
      }
    },
    goBack() {
      if (window.history.length > 1) {
        this.$router.back();
        return;
      }
      this.$router.push("/studyPage");
    }
  }
};
</script>

<style lang="scss">
.practice-instruction-dialog {
  width: 680px !important;
  max-width: 90%;
  border-radius: 8px !important;
  padding-bottom: 10px;

  .el-message-box__header {
    background: #f7f9fb;
    border-radius: 8px 8px 0 0;
    padding: 20px 24px;
    border-bottom: 1px solid #ebeef5;
  }

  .el-message-box__title {
    font-size: 18px;
    font-weight: 600;
    color: #1f2530;
  }

  .el-message-box__content {
    font-size: 15px;
    line-height: 1.8;
    color: #444a57;
    padding: 30px 24px;
  }

  .el-message-box__btns {
    padding: 10px 24px 20px;
    text-align: center;

    .el-button--primary {
      background: #3f93dc;
      border-color: #3f93dc;
      border-radius: 20px;
      padding: 10px 32px;
      font-size: 15px;
      letter-spacing: 1px;
      box-shadow: 0 4px 10px rgba(63, 147, 220, 0.3);
      transition: all 0.2s;

      &:hover {
        background: #50a1e8;
        transform: translateY(-1px);
        box-shadow: 0 6px 14px rgba(63, 147, 220, 0.4);
      }

      &:active {
        transform: translateY(1px);
        box-shadow: 0 2px 6px rgba(63, 147, 220, 0.3);
      }
    }
  }
}
</style>

<style scoped lang="scss">
.choice-practice-base-page {
  min-height: calc(100vh - 170px);
  padding: 30px 0 40px;
  background: #f5f7fa;
}

.choice-shell {
  width: 900px;
  max-width: 95%;
  margin: 0 auto;
}

.choice-module {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.choice-title {
  height: 60px;
  line-height: 60px;
  text-align: center;
  color: #ffffff;
  font-size: 20px;
  font-weight: 500;
  background: #3f93dc;
  letter-spacing: 1px;
}

.choice-card {
  padding: 30px 50px 40px;
}

.choice-group {
  margin-top: 10px;
}

.choice-item {
  display: flex;
  align-items: center;
  min-height: 48px;
  margin-bottom: 6px;
  padding: 0 20px;
  border-radius: 6px;
  transition: background-color 0.2s;

  &:hover {
    background: #f9fbfd;
  }
}

.choice-name {
  color: #2f3136;
  font-size: 16px;
  line-height: 1.4;

  &.is-selected {
    color: #3f93dc;
    font-weight: 600;
  }
}

.wish-label {
  margin-left: 20px;
  padding: 2px 10px;
  font-size: 13px;
  font-weight: 500;
  color: #ff4d4f;
  background: #fff2f0;
  border: 1px solid #ffccc7;
  border-radius: 12px;
}

.choice-actions {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}

.confirm-btn {
  width: 240px;
  height: 48px;
  border: none;
  border-radius: 24px;
  background: #3f93dc;
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  letter-spacing: 2px;
  transition: all 0.3s;
  box-shadow: 0 4px 12px rgba(63, 147, 220, 0.3);

  &:hover {
    background: #50a1e8;
    box-shadow: 0 6px 16px rgba(63, 147, 220, 0.4);
    transform: translateY(-1px);
  }

  &:active {
    background: #3182c8;
    box-shadow: 0 2px 8px rgba(63, 147, 220, 0.3);
    transform: translateY(1px);
  }
}

::v-deep .el-checkbox__label {
  padding-left: 12px;
}

::v-deep .el-checkbox__inner {
  width: 18px;
  height: 18px;
  border-color: #dcdfe6;

  &::after {
    height: 9px;
    left: 6px;
    top: 2px;
    width: 4px;
  }
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #3f93dc;
  border-color: #3f93dc;
}
</style>
